import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';
import {ThuFile} from './thufile';


export  class Thu implements Deserializable
{
  public  id: number;
  public  vanDe: string;
  public  noiDung: string;
  public  noiDungShort: string;
  public  ngayNhap: string;
  public  nguoiTao: number;
  public  tenNguoitao: string;
  public  nguoiNhan: number;
  public  nguoinhanTen: string;
  public  nguoiNhanID: string;
  public  timeAd: string;
  public  timeReply: string;
  public  thoiHan: string;
  public  checkread: number;
  public  suDung: number;
  public  ngayTao: string;
  public  nhomThu: number;
  public  flagConfirm: number;
  public  nguoiGui: Staffs;
  public thuFiles: ThuFile[];
  public  status: number;
  public  replyId: number;
  public  nguoiNhanThu: Staffs;
  public  nguoiGuiGoc: Staffs;
  public  thuGoc: number;
  public  ghim: number;
  public  nguoiGuiGocId: number;
  public  traLoi: number;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.thuFiles = input.thuFiles != null ? input.thuFiles.map(thuFiles => new ThuFile().deserialize(thuFiles)): null;
    this.nguoiGui = input.nguoiGui != null ? new Staffs().deserialize(input.nguoiGui): null;
    this.nguoiGuiGoc = input.nguoiGuiGoc != null ? new Staffs().deserialize(input.nguoiGuiGoc) : null;
    this.nguoiNhanThu = input.nguoiNhanThu != null ? new Staffs().deserialize(input.nguoiNhanThu): null;
    return this;
  }
}
